import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { finalizeLoader } from '@shared/components/loader/operators/handle-loader';
import { quizActions } from '../actions/quizes.actions';
import { QuizHttpService } from '../services/http.service';

@Injectable({
    providedIn: 'root',
})
export class QuizEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(QuizHttpService);

    getQuiz$ = createEffect(() => {
        return this.actions.pipe(
            ofType(quizActions.getQuiz),
            mergeMap(({ id }) =>
                this.httpService.getQuiz(id).pipe(
                    finalizeLoader('library-get-quiz'),
                    map((payload) => quizActions.getQuizSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(quizActions.getQuizError({ code: error.status }))),
                ),
            ),
        );
    });
}
